<template>
    <Tippy
        placement="top"
        animation="scale"
        :trigger="triggers"
        :interactive="interactive"
        :appendTo="appendTo"
        :delay="[100, 100]"
        :duration="[100, 100]"
        :offset="[0, 5]"
        :popperOptions="mergedPopperOptions"
        :on-show="() => !$props.disabled"
        :append-to="appendTo"
    >
        <template #default>
            <slot v-bind="{ open: open }" />
        </template>
        <template #content>
            <div class="whitespace-pre-line rounded-muval-2 border bg-white px-2 py-1 text-muval-gray-1 shadow-muval-1">
                <slot name="content" />
            </div>
        </template>
    </Tippy>
</template>

<script setup>
import 'tippy.js/animations/scale.css';
import { computed } from 'vue';

const open = ref(false);

const props = defineProps({
    triggers: {
        type: String,
        default: 'click mouseenter',
        validator: (value) => {
            return value.includes('click') || value.includes('mouseenter');
        },
    },
    interactive: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
    popperOptions: {
        type: Object,
        default: null,
    },
    appendTo: {
        type: [String, Function, Object],
        default: () => document.body,
    },
});

const defaultPopperOptions = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'preventOverflow',
            options: {
                altAxis: true,
                tether: false,
            },
        },
    ],
};

const mergedPopperOptions = computed(() => {
    if (!props.popperOptions) {
        return defaultPopperOptions;
    }

    return {
        ...defaultPopperOptions,
        ...props.popperOptions,
        modifiers: [...defaultPopperOptions.modifiers, ...(props.popperOptions.modifiers || [])],
    };
});
</script>
